export default "__VITE_ASSET__BCP6ItwB__"